import { render, staticRenderFns } from "./AdministrativeLevelView.vue?vue&type=template&id=2c341be1&"
import script from "./AdministrativeLevelView.vue?vue&type=script&lang=js&"
export * from "./AdministrativeLevelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports